import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import _ from "lodash";

import Wrapper from "../components/Wrapper";
import Header from "../components/Header";
import Body from "../components/Body";
import TopBar from "../components/TopBar";
import SubmitButton from "../components/SubmitButton";

import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";

import Corona from "../assets/images/corona.png";
import Dpy from "../assets/images/dpy.png";
import Icon1 from "../assets/images/icon_1.png";
import Icon2 from "../assets/images/icon_2.png";
import Collapse from "@material-ui/core/Collapse";

const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal",
  color: "rgb(14 22 44)"
};

const styles = {
  textTopBar: {
    ...fontDefault,
    color: "#333333",
    fontSize: "18px",
    fontWeight: "bold"
  },
  expandButton: {
    marginLeft: "15px",
    marginRight: "15px",
    marginBottom: "15px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  expandText: {
    ...fontDefault,
    color: "#118DF5",
    fontSize: "14px"
  },
  expandIcon: {
    color: "#118DF5",
    fontSize: "20px"
  },
  topSection: {
    backgroundColor: "white",
    padding: "16px"
  },
  topText: {
    ...fontDefault,
    fontSize: "16px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "24px"
  },
  flexCenter: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  topIcon: {
    width: "130px"
  },
  topDpyImage: {
    marginTop: "8px",
    width: "150px",
    marginBottom: "16px"
  },
  secondSection: {
    backgroundColor: "white",
    marginTop: "8px",
    padding: "16px"
  },
  secondHead: {
    ...fontDefault,
    fontSize: "16px",
    fontWeight: "bold",
    textAlign: "center"
  },
  secondText: {
    ...fontDefault,
    fontSize: "16px",
    textAlign: "center",
    marginTop: "16px",
    marginBottom: "24px"
  },
  secondIconContainer: {
    padding: "10px 0px",
    display: "flex",
    alignItems: "center"
  },
  secondIcon1: {
    width: "60px"
  },
  secondIcon2: {
    width: "60px"
  },
  secondIconText: {
    ...fontDefault,
    fontSize: "14px",
    color: "#878b96",
    marginLeft: "20px"
  },
  thirdHeadText: {
    ...fontDefault,
    fontSize: "16px",
    fontWeight: "bold"
  },
  thirdHead: {
    display: "flex",
    justifyContent: "space-between"
  },
  thirdExpandIcon: {
    fontSize: "20px",
    color: "#333333"
  },
  thirdSeperate: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "16px"
  },
  number: {
    ...fontDefault,
    fontSize: "14px",
    color: "#878b96",
    marginRight: "8px"
  },
  sText: {
    ...fontDefault,
    fontSize: "14px",
    color: "#878b96"
  },
  lastSection: {
    ...fontDefault,
    fontSize: "12px",
    color: "rgb(135 139 150)",
    textAlign: "center",
    marginBottom: "24px"
  },
  lastSectionButton: {
    ...fontDefault,
    color: "rgb(20 123 209)",
    fontSize: "16px",
    textAlign: "center",
    marginTop: "8px",
    marginBottom: "24px"
  }
};

class App extends Component {
  state = {
    isExpand: false
  };

  goToNextPage = () => {
    const mixpanel = _.get(window, "mixpanel", undefined);
    if (!!mixpanel) {
      mixpanel.track("Insurance Corona Enter", {});
    }
    const {
      history: { push }
    } = this.props;
    push("/packages-old");
    document.getElementById("rootScreen").scrollTo(0, 0);
  };

  componentDidMount = () => {};

  render = () => {
    const { classes } = this.props;
    const { isExpand } = this.state;
    return (
      <Wrapper>
        <Body>
          <div className={classes.topSection}>
            <div className={classes.flexCenter}>
              <img src={Corona} className={classes.topIcon} alt="sick_icon" />
              <img src={Dpy} className={classes.topDpyImage} alt="dpy" />
            </div>
            <Typography className={classes.topText}>
              ประกันภัยส่วนบุคคลคุ้มครองการติดเชื้อไวรัสโคโรนา (Coronavirus
              (2019-nCoV))
            </Typography>
            <SubmitButton onClick={this.goToNextPage} margin={false}>
              เลือกแผนประกันภัยไวรัสโคโรนา
            </SubmitButton>
          </div>
          <div className={classes.secondSection}>
            <Typography className={classes.secondHead}>ความคุ้มครอง</Typography>
            <Typography className={classes.secondText}>
              การประกันภัยส่วนบุคคลคุ้มครองการติดเชื้อ ไวรัสโคโรนา (Coronavirus
              (2019-nCoV)) ด้วยแผนคุ้มครองที่เหมาะสม คุ้มครองต่อเนื่อง
              จนระยะสุดท้าย ชดเชยสูงสุด 1,000,000 บาท
              พร้อมดูแลคุณและคนที่คุณรักจากไวรัสโคโรนา
            </Typography>
            <div className={classes.secondIconContainer}>
              <img src={Icon1} alt="icon1" className={classes.secondIcon1} />
              <Typography className={classes.secondIconText}>
                การเจ็บป่วยด้วยภาวะหรือโรคร้ายแรง
                ที่มีสาเหตุมาจากการติดเชื้อไวรัสโคโรนา (Coronavirus
                (2019-nCoV))**
              </Typography>
            </div>
            <div className={classes.secondIconContainer}>
              <img src={Icon2} alt="icon2" className={classes.secondIcon2} />
              <Typography className={classes.secondIconText}>
                การรักษาพยาบาลจากการติดเชื้อไวรัสโคโรนา (Coronavirus
                (2019-nCoV))
              </Typography>
            </div>
            <Typography className={classes.sText}>หมายเหตุ</Typography>
            <Typography className={classes.sText}>
              ** การเจ็บป่วยด้วยภาวะโคม่า หรือ ภาวะสมองตายและระบบประสาทล้มเหลว
              หรือ
              การเจ็บป่วยระยะสุดท้ายซึ่งเป็นการเจ็บป่วยรุนแรงที่แพทย์ลงความเห็นว่าไม่มีวิธีการรักษาให้หายได้
              และ/หรือ
              เป็นสาเหตุทำให้เสียชีวิตโดยมีสาเหตุหลักมาจากติดเชื้อไวรัสโคโรนา
            </Typography>
            {false && (
              <div
                className={classes.expandButton}
                onClick={() => {
                  this.setState({
                    isExpand: !isExpand
                  });
                }}
              >
                <span className={classes.expandText}>
                  ดูความคุ้มครองอย่างละเอียด
                </span>
                <Icon className={classes.expandIcon}>
                  {isExpand ? "expand_less" : "expand_more"}
                </Icon>
              </div>
            )}
          </div>
          <div className={classes.secondSection}>
            <div
              className={classes.thirdHead}
              button
              onClick={() => {
                this.setState({
                  isExpand: !!!isExpand
                });
              }}
            >
              <Typography className={classes.thirdHeadText}>
                เงื่อนไขการประกันภัยส่วนบุคคลคุ้มครองการติดเชื้อไวรัสโคโรนา
              </Typography>
              <Icon className={classes.thirdExpandIcon}>
                {!!isExpand === false ? "expand_more" : "expand_less"}
              </Icon>
            </div>
            <Collapse in={isExpand} timeout="auto" unmountOnExit>
              <br />
              <div className={classes.thirdSeperate}>
                <Typography className={classes.number}>1)</Typography>
                <Typography className={classes.sText}>
                  ผู้เอาประกันภัยอายุระหว่าง 1 ปี - 99 ปี (ปี พ.ศ. ปัจจุบัน
                  ลบด้วยปี พ.ศ. เกิด) ณ วันที่ทำประกันภัย และ
                  ต้องมีสุขภาพร่างกายสมบูรณ์แข็งแรง ไม่พิการ
                  ไม่เป็นโรคเรื้อรังและผ่านการพิจารณารับประกันภัย
                </Typography>
              </div>
              <div className={classes.thirdSeperate}>
                <Typography className={classes.number}>2)</Typography>
                <Typography className={classes.sText}>
                  กรมธรรม์ประกันภัยนี้ไม่คุ้มครองผู้ที่ติดเชื้อ หรือเป็น
                  ผู้ที่สงสัยว่าจะติดเชื้อ “โรคติดเชื้อไวรัสโคโรนา (Coronavirus
                  (2019-nCoV))” (รวมถึงภาวะ แทรกซ้อน)
                  ที่เป็นอยู่ก่อนการเอาประกันภัย และยังมิได้ รักษาให้หายขาด
                </Typography>
              </div>
              <div className={classes.thirdSeperate}>
                <Typography className={classes.number}>3)</Typography>
                <Typography className={classes.sText}>
                  จำกัดการซื้อ 1 คน ต่อจำนวนเงินเอาประกันภัยไม่เกิน 1 ล้านบาท
                  และ/หรือค่ารักษาพยาบาลรวมกันไม่เกิน 1 แสนบาท
                </Typography>
              </div>
              <div className={classes.thirdSeperate}>
                <Typography className={classes.number}>4)</Typography>
                <Typography className={classes.sText}>
                  **การเจ็บป่วยด้วยภาวะโคม่า หรือ ภาวะสมองตายและ
                  ระบบประสาทล้มเหลว หรือ
                  การเจ็บป่วยระยะสุดท้ายซึ่ง เป็นการเจ็บป่วยรุนแรงที่แพทย์ลงความเห็นว่าไม่มีวิธี
                  การรักษาให้หายได้ และ/หรือ เป็นสาเหตุทำให้เสียชีวิต
                  โดยมีสาเหตุหลักมาจากติดเชื้อไวรัสโคโรนา
                </Typography>
              </div>
              <div className={classes.thirdSeperate}>
                <Typography className={classes.number}>5)</Typography>
                <Typography className={classes.sText}>
                  ผลประโยชน์และความคุ้มครองเป็นไปตามข้อกำหนดและ
                  เงื่อนไขกรมธรรม์ประกันภัยคุ้มครองการติดเชื้อไวรัส โคโรนา
                  (Coronavirus (2019-nCoV))
                </Typography>
              </div>
            </Collapse>
          </div>
          <div className={classes.secondSection}>
            <Typography className={classes.lastSection}>
              ทรูมันนี่ วอลเล็ทเป็นเพียงช่องทางชำระเงิน
              และทำหน้าที่เป็นช่องทางในการเชื่อมต่อขอรับบริการทางอิเล็กทรอนิกส์
              กับบมจ.ทิพยประกันภัยเท่านั้น ทรูมันนี่
              วอลเล็ทไม่มีส่วนเกี่ยวข้องในการพิจารณา
              หรือรับผิดชอบในการรับประกันภัย
            </Typography>
            {false && (
              <Typography className={classes.lastSectionButton}>
                นโยบายการคุ้มครองส่วนบุคคล
              </Typography>
            )}
            <SubmitButton onClick={this.goToNextPage}>
              เลือกแผนประกันภัยไวรัสโคโรนา
            </SubmitButton>
          </div>
        </Body>
        <Header>
          <TopBar
            arrowLeft={() => {
              window.location.replace("ascendmoney://closewebview");
            }}
          >
            <Typography align="center" className={classes.textTopBar}>
              ประกันภัยไวรัสโคโรนา
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth || {}
  };
};

export default connect(mapStateToProps)(withStyles(styles)(App));
